export default __webpack_public_path__ + "images/fd5b6d4fdabfccbe9d4f4ee1189c36df.svg";